import React, { useEffect, useMemo } from 'react';
import { Table } from 'antd';
import useTableData from '../../hooks/useTableData.hook';
import styles from './UTable.module.css';

const UniversalTable = ({
	endpoint,
	columns,
	usePagination = true,
	initialPage = 1,
	initialPageSize = 10,
	filters = {},
	tableProps = {},
	onTotalRecordsChange = () => {},
	formatData = item => item,
	refreshKey = null
}) => {
	const { data, pagination, loading, fetchData } = useTableData({
		endpoint,
		initialPage,
		initialPageSize,
		usePagination,
		filters,
		refreshKey
	});

	const formattedData = useMemo(() => {
		if (Array.isArray(data)) {
			return data.map(item => formatData(item));
		} else {
			return formatData(data);
		}
	}, [data, formatData]);

	// Для серверной пагинации - берём total из pagination
	// Для клиентской пагинации - берём длину данных
	useEffect(() => {
		if (usePagination) {
			if (pagination?.total !== undefined) {
				onTotalRecordsChange(pagination.total);
			}
		} else {
			onTotalRecordsChange(formattedData?.length || 0);
		}
	}, [pagination?.total, formattedData?.length, usePagination, onTotalRecordsChange]);

	const handleTableChange = (paginationConfig) => {
		if (usePagination) {
			fetchData(paginationConfig.current, paginationConfig.pageSize);
		}
	};

	return (
		<div className={styles.tableWrapper}>
			<div className={styles.tableContainer}>
				<Table
					size="small"
					className={styles.customTable}
					columns={columns}
					dataSource={formattedData}
					loading={loading}
					rowKey={record => record.id}
					onChange={handleTableChange}
					pagination={{
						...(usePagination
							? pagination
							: { defaultPageSize: initialPageSize }
						),
						showSizeChanger: true,
						pageSizeOptions: ['10', '15', '20', '50', '100']
					}}
					{...tableProps}
				/>
			</div>
		</div>
	);
};

export default UniversalTable;
